<template>
  <div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="date" label="序号"> </el-table-column>
      <el-table-column prop="name" label="操作人员"> </el-table-column>
      <el-table-column prop="address" label="审核总量"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">
            明细
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pager-wrap" style="text-align:right;margin:10px 0px;">
      <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="audistCount"
        @pageChanged="handleCurrentChange"
      ></pagination>
    </div>
    <el-dialog title="明细" :visible.sync="dialogTableVisible">
      <div class="page-actions">
        <el-date-picker
          v-model="dataArry"
          type="datetimerange"
          value-format="timestamp"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        ></el-date-picker>
        <el-button type="primary">查询</el-button>
        <p>审核数量：32793条</p>
      </div>
      <el-table :data="gridData">
        <el-table-column property="date" label="序号"></el-table-column>
        <el-table-column property="date" label="时间"></el-table-column>
        <el-table-column property="name" label="审核数量"></el-table-column>
        <el-table-column property="address" label="操作人员"></el-table-column>
      </el-table>
      <div class="pager-wrap" style="text-align:right;margin:10px 0px;">
        <pagination
          :size="pagination.size"
          :page="pagination.page"
          :total="audistCount"
          @pageChanged="handleCurrentChange"
        ></pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from 'components/pagination';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      tableData: [
        {
          date: 1,
          name: 'user',
          address: 200
        }
      ],
      pagination: {
        size: 25,
        page: 1
      },
      audistCount: 0,
      dialogTableVisible: false,
      dataArry: [],
      gridData: []
    };
  },
  methods: {
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    handleClick(item) {
      this.dialogTableVisible = true;
      // eslint-disable-next-line no-console
      console.log(item);
    }
  }
};
</script>
